"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1707,6719],{

/***/ 16719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CustomButtons_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/makeStyles.js
var makeStyles = __webpack_require__(32427);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/buttonStyle.js

var buttonStyle = {
    button: {
        minHeight: "auto",
        minWidth: "auto",
        backgroundColor: bbhost/* grayColor */.X_,
        color: "#FFFFFF",
        boxShadow: "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
        border: "none",
        borderRadius: "3px",
        position: "relative",
        padding: "12px 30px",
        margin: ".3125rem 1px",
        fontSize: "12px",
        fontWeight: "400",
        textTransform: "uppercase",
        letterSpacing: "0",
        willChange: "box-shadow, transform",
        transition: "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        lineHeight: "1.42857143",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        touchAction: "manipulation",
        cursor: "pointer",
        "&:hover,&:focus": {
            color: "#FFFFFF",
            backgroundColor: bbhost/* grayColor */.X_,
            boxShadow: "0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            display: "inline-block",
            top: "0",
            fontSize: "1.1rem",
            marginRight: "4px",
            verticalAlign: "middle"
        },
        "& svg": {
            position: "relative",
            display: "inline-block",
            top: "0",
            width: "18px",
            height: "18px",
            marginRight: "4px",
            verticalAlign: "middle"
        },
        "&$justIcon": {
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                marginRight: "0px",
                position: "absolute",
                width: "100%",
                transform: "none",
                left: "0px",
                top: "0px",
                height: "100%",
                lineHeight: "41px",
                fontSize: "20px"
            }
        }
    },
    fullWidth: {
        width: "100%"
    },
    primary: {
        backgroundColor: bbhost/* primaryColor */.lr,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* primaryColor */.lr,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2))
        }
    },
    info: {
        backgroundColor: bbhost/* infoColor */.bE,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* infoColor */.bE,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.2))
        }
    },
    success: {
        backgroundColor: bbhost/* successColor */.nq,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* successColor */.nq,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.2))
        }
    },
    warning: {
        backgroundColor: bbhost/* warningColor */.MA,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* warningColor */.MA,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.2))
        }
    },
    danger: {
        backgroundColor: bbhost/* dangerColor */.E7,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* dangerColor */.E7,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.2))
        }
    },
    rose: {
        backgroundColor: bbhost/* roseColor */.An,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* roseColor */.An,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2))
        }
    },
    white: {
        "&,&:focus,&:hover,&:visited": {
            backgroundColor: "#FFFFFF",
            color: bbhost/* grayColor */.X_
        }
    },
    twitter: {
        backgroundColor: "#55acee",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)",
        "&:hover,&:focus,&:visited": {
            backgroundColor: "#55acee",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)"
        }
    },
    facebook: {
        backgroundColor: "#3b5998",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)",
        "&:hover,&:focus": {
            backgroundColor: "#3b5998",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)"
        }
    },
    google: {
        backgroundColor: "#dd4b39",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)",
        "&:hover,&:focus": {
            backgroundColor: "#dd4b39",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"
        }
    },
    github: {
        backgroundColor: "#333333",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)",
        "&:hover,&:focus": {
            backgroundColor: "#333333",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)"
        }
    },
    simple: {
        "&,&:focus,&:hover,&:visited": {
            color: "#FFFFFF",
            background: "transparent",
            boxShadow: "none"
        },
        "&$primary": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* primaryColor */.lr
            }
        },
        "&$info": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* infoColor */.bE
            }
        },
        "&$success": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* successColor */.nq
            }
        },
        "&$warning": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* warningColor */.MA
            }
        },
        "&$rose": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* roseColor */.An
            }
        },
        "&$danger": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* dangerColor */.E7
            }
        },
        "&$twitter": {
            "&,&:focus,&:hover,&:visited": {
                color: "#55acee"
            }
        },
        "&$facebook": {
            "&,&:focus,&:hover,&:visited": {
                color: "#3b5998"
            }
        },
        "&$google": {
            "&,&:focus,&:hover,&:visited": {
                color: "#dd4b39"
            }
        },
        "&$github": {
            "&,&:focus,&:hover,&:visited": {
                color: "#333333"
            }
        }
    },
    transparent: {
        "&,&:focus,&:hover,&:visited": {
            color: "inherit",
            background: "transparent",
            boxShadow: "none"
        }
    },
    disabled: {
        opacity: "0.65",
        pointerEvents: "none"
    },
    lg: {
        padding: "1.125rem 2.25rem",
        fontSize: "0.875rem",
        lineHeight: "1.333333",
        borderRadius: "0.2rem"
    },
    sm: {
        padding: "0.40625rem 1.25rem",
        fontSize: "0.6875rem",
        lineHeight: "1.5",
        borderRadius: "0.2rem"
    },
    round: {
        borderRadius: "30px"
    },
    block: {
        width: "100% !important"
    },
    link: {
        "&,&:hover,&:focus": {
            backgroundColor: "transparent",
            color: "#999999",
            boxShadow: "none"
        }
    },
    justIcon: {
        paddingLeft: "12px",
        paddingRight: "12px",
        fontSize: "20px",
        height: "41px",
        minWidth: "41px",
        width: "41px",
        "& .fab,& .fas,& .far,& .fal,& svg,& .material-icons": {
            marginRight: "0px"
        },
        "&$lg": {
            height: "57px",
            minWidth: "57px",
            width: "57px",
            lineHeight: "56px",
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "32px",
                lineHeight: "56px"
            },
            "& svg": {
                width: "32px",
                height: "32px"
            }
        },
        "&$sm": {
            height: "30px",
            minWidth: "30px",
            width: "30px",
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "17px",
                lineHeight: "29px"
            },
            "& svg": {
                width: "17px",
                height: "17px"
            }
        }
    }
};
/* harmony default export */ var components_buttonStyle = (buttonStyle);

;// CONCATENATED MODULE: ./components/CustomButtons/Button.js






// nodejs library to set properties for components

// nodejs library that concatenates classes

// @material-ui/core components


// core components

var makeComponentStyles = (0,makeStyles/* default */.Z)(function() {
    return (0,_object_spread/* default */.Z)({}, components_buttonStyle);
});
var RegularButton = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var color = props.color, round = props.round, children = props.children, fullWidth = props.fullWidth, disabled = props.disabled, simple = props.simple, size = props.size, block = props.block, link = props.link, justIcon = props.justIcon, className = props.className, rest = (0,_object_without_properties/* default */.Z)(props, [
        "color",
        "round",
        "children",
        "fullWidth",
        "disabled",
        "simple",
        "size",
        "block",
        "link",
        "justIcon",
        "className"
    ]);
    var classes = makeComponentStyles();
    var _obj;
    var btnClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.button, true), (0,_define_property/* default */.Z)(_obj, classes[size], size), (0,_define_property/* default */.Z)(_obj, classes[color], color), (0,_define_property/* default */.Z)(_obj, classes.round, round), (0,_define_property/* default */.Z)(_obj, classes.fullWidth, fullWidth), (0,_define_property/* default */.Z)(_obj, classes.disabled, disabled), (0,_define_property/* default */.Z)(_obj, classes.simple, simple), (0,_define_property/* default */.Z)(_obj, classes.block, block), (0,_define_property/* default */.Z)(_obj, classes.link, link), (0,_define_property/* default */.Z)(_obj, classes.justIcon, justIcon), (0,_define_property/* default */.Z)(_obj, className, className), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        ref: ref,
        classes: {
            root: btnClasses
        },
        children: children
    }));
});
RegularButton.propTypes = {
    color: prop_types_default().oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "rose",
        "white",
        "facebook",
        "twitter",
        "google",
        "github",
        "transparent", 
    ]),
    size: prop_types_default().oneOf([
        "sm",
        "lg"
    ]),
    simple: (prop_types_default()).bool,
    round: (prop_types_default()).bool,
    fullWidth: (prop_types_default()).bool,
    disabled: (prop_types_default()).bool,
    block: (prop_types_default()).bool,
    link: (prop_types_default()).bool,
    justIcon: (prop_types_default()).bool,
    children: (prop_types_default()).node,
    className: (prop_types_default()).string
};
RegularButton.displayName = "RegularButton";
/* harmony default export */ var CustomButtons_Button = (RegularButton);


/***/ }),

/***/ 61707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomDropdown; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuList/MenuList.js
var MenuList = __webpack_require__(29829);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/Grow.js
var Grow = __webpack_require__(20170);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Icon/Icon.js
var Icon = __webpack_require__(92863);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popper/Popper.js + 1 modules
var Popper = __webpack_require__(84872);
// EXTERNAL MODULE: ./components/CustomButtons/Button.js + 1 modules
var Button = __webpack_require__(16719);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/customDropdownStyle.js




var customDropdownStyle = function(theme) {
    return {
        popperClose: {
            pointerEvents: "none"
        },
        pooperNav: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("sm"), {
            position: "static !important",
            left: "unset !important",
            top: "unset !important",
            transform: "none !important",
            willChange: "none !important",
            "& > div": {
                boxShadow: "none !important",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                transition: "none !important",
                marginTop: "0px !important",
                marginBottom: "5px !important",
                padding: "0px !important"
            }
        }),
        dropdown: {
            borderRadius: "3px",
            border: "0",
            boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.26)",
            top: "100%",
            zIndex: "1000",
            minWidth: "160px",
            padding: "5px 0",
            margin: "2px 0 0",
            fontSize: "14px",
            textAlign: "left",
            listStyle: "none",
            backgroundColor: "#fff",
            backgroundClip: "padding-box"
        },
        menuList: {
            padding: "0"
        },
        popperResponsive: (0,_define_property/* default */.Z)({
            zIndex: "1200",
            position: "absolute !important"
        }, theme.breakpoints.down("sm"), {
            zIndex: "1640",
            position: "static !important",
            float: "none",
            width: "auto",
            marginTop: "0",
            backgroundColor: "transparent",
            border: "0",
            boxShadow: "none",
            color: "black"
        }),
        dropdownItem: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bbhost/* defaultFont */.Df), {
            fontSize: "13px",
            padding: "10px 20px",
            margin: "0 5px",
            borderRadius: "2px",
            position: "relative",
            transition: "all 150ms linear",
            display: "block",
            clear: "both",
            fontWeight: "400",
            height: "fit-content",
            color: "#333",
            whiteSpace: "nowrap",
            minHeight: "unset"
        }),
        blackHover: {
            "&:hover": {
                boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(33, 33, 33, 0.4)",
                backgroundColor: "#212121",
                color: "#fff"
            }
        },
        primaryHover: {
            "&:hover": (0,_object_spread/* default */.Z)({
                backgroundColor: bbhost/* primaryColor */.lr,
                color: "#FFFFFF"
            }, bbhost/* primaryBoxShadow */.kY)
        },
        infoHover: {
            "&:hover": (0,_object_spread/* default */.Z)({
                backgroundColor: bbhost/* infoColor */.bE,
                color: "#FFFFFF"
            }, bbhost/* infoBoxShadow */.ur)
        },
        successHover: {
            "&:hover": (0,_object_spread/* default */.Z)({
                backgroundColor: bbhost/* successColor */.nq,
                color: "#FFFFFF"
            }, bbhost/* successBoxShadow */.TI)
        },
        warningHover: {
            "&:hover": (0,_object_spread/* default */.Z)({
                backgroundColor: bbhost/* warningColor */.MA,
                color: "#FFFFFF"
            }, bbhost/* warningBoxShadow */.D6)
        },
        dangerHover: {
            "&:hover": (0,_object_spread/* default */.Z)({
                backgroundColor: bbhost/* dangerColor */.E7,
                color: "#FFFFFF"
            }, bbhost/* dangerBoxShadow */.iW)
        },
        roseHover: {
            "&:hover": (0,_object_spread/* default */.Z)({
                backgroundColor: bbhost/* roseColor */.An,
                color: "#FFFFFF"
            }, bbhost/* roseBoxShadow */.cq)
        },
        dropdownItemRTL: {
            textAlign: "right"
        },
        dropdownDividerItem: {
            margin: "5px 0",
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            height: "1px",
            overflow: "hidden"
        },
        buttonIcon: {
            width: "20px",
            height: "20px"
        },
        caret: {
            transition: "all 150ms ease-in",
            display: "inline-block",
            width: "0",
            height: "0",
            marginLeft: "4px",
            verticalAlign: "middle",
            borderTop: "4px solid",
            borderRight: "4px solid transparent",
            borderLeft: "4px solid transparent"
        },
        caretActive: {
            transform: "rotate(180deg)"
        },
        caretRTL: {
            marginRight: "4px"
        },
        dropdownHeader: {
            display: "block",
            padding: "0.1875rem 1.25rem",
            fontSize: "0.75rem",
            lineHeight: "1.428571",
            color: "#777",
            whiteSpace: "nowrap",
            fontWeight: "inherit",
            marginTop: "10px",
            minHeight: "unset",
            "&:hover,&:focus": {
                backgroundColor: "transparent",
                cursor: "auto"
            }
        },
        noLiPadding: {
            padding: "0"
        }
    };
};
/* harmony default export */ var components_customDropdownStyle = (customDropdownStyle);

;// CONCATENATED MODULE: ./components/CustomDropdown/CustomDropdown.js







// nodejs library that concatenates classes

// nodejs library to set properties for components

// @material-ui/core components









// core components


var useStyles = (0,makeStyles/* default */.Z)(components_customDropdownStyle);
function CustomDropdown(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        if (anchorEl && anchorEl.contains(event.target)) {
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };
    var handleClose = function(param) {
        setAnchorEl(null);
        if (props && props.onClick) {
            props.onClick(param);
        }
    };
    var handleCloseAway = function(event) {
        if (anchorEl.contains(event.target)) {
            return;
        }
        setAnchorEl(null);
    };
    var classes = useStyles();
    var buttonText = props.buttonText, buttonIcon = props.buttonIcon, dropdownList = props.dropdownList, buttonProps = props.buttonProps, dropup = props.dropup, dropdownHeader = props.dropdownHeader, caret = props.caret, hoverColor = props.hoverColor, left = props.left, rtlActive = props.rtlActive, noLiPadding = props.noLiPadding, navDropdown = props.navDropdown;
    var _obj;
    var caretClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.caret, true), (0,_define_property/* default */.Z)(_obj, classes.caretActive, Boolean(anchorEl)), (0,_define_property/* default */.Z)(_obj, classes.caretRTL, rtlActive), _obj));
    var _obj1;
    var dropdownItem = classnames_default()((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, classes.dropdownItem, true), (0,_define_property/* default */.Z)(_obj1, classes[hoverColor + "Hover"], true), (0,_define_property/* default */.Z)(_obj1, classes.noLiPadding, noLiPadding), (0,_define_property/* default */.Z)(_obj1, classes.dropdownItemRTL, rtlActive), _obj1));
    var icon = null;
    switch(typeof buttonIcon === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(buttonIcon)){
        case "object":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(props.buttonIcon, {
                className: classes.buttonIcon
            });
            break;
        case "string":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                className: classes.buttonIcon,
                children: props.buttonIcon
            });
            break;
        default:
            icon = null;
            break;
    }
    var _obj2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    "aria-label": "Notifications",
                    "aria-owns": anchorEl ? "menu-list" : null,
                    "aria-haspopup": "true"
                }, buttonProps), {
                    onClick: handleClick,
                    children: [
                        icon,
                        buttonText !== undefined ? buttonText : null,
                        caret ? /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            className: caretClasses
                        }) : null
                    ]
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                open: Boolean(anchorEl),
                anchorEl: anchorEl,
                transition: true,
                disablePortal: true,
                placement: dropup ? left ? "top-start" : "top" : left ? "bottom-start" : "bottom",
                className: classnames_default()((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, classes.popperClose, !anchorEl), (0,_define_property/* default */.Z)(_obj2, classes.popperResponsive, true), (0,_define_property/* default */.Z)(_obj2, classes.pooperNav, Boolean(anchorEl) && navDropdown), _obj2)),
                children: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                        in: Boolean(anchorEl),
                        id: "menu-list",
                        style: dropup ? {
                            transformOrigin: "0 100% 0"
                        } : {
                            transformOrigin: "0 0 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                            className: classes.dropdown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                                onClickAway: handleCloseAway,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList/* default */.Z, {
                                    role: "menu",
                                    className: classes.menuList,
                                    children: [
                                        dropdownHeader !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                            onClick: function() {
                                                return handleClose(dropdownHeader);
                                            },
                                            className: classes.dropdownHeader,
                                            children: dropdownHeader
                                        }) : null,
                                        dropdownList.map(function(prop, key) {
                                            if (prop.divider) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                    onClick: function() {
                                                        return handleClose("divider");
                                                    },
                                                    className: classes.dropdownDividerItem
                                                }, key);
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                onClick: function() {
                                                    return handleClose(prop);
                                                },
                                                className: dropdownItem,
                                                children: prop
                                            }, key);
                                        })
                                    ]
                                })
                            })
                        })
                    });
                }
            })
        ]
    });
}
CustomDropdown.defaultProps = {
    caret: true,
    hoverColor: "primary"
};
CustomDropdown.propTypes = {
    hoverColor: prop_types_default().oneOf([
        "black",
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "rose", 
    ]),
    buttonText: (prop_types_default()).node,
    buttonIcon: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ]),
    dropdownList: (prop_types_default()).array,
    buttonProps: (prop_types_default()).object,
    dropup: (prop_types_default()).bool,
    dropdownHeader: (prop_types_default()).node,
    rtlActive: (prop_types_default()).bool,
    caret: (prop_types_default()).bool,
    left: (prop_types_default()).bool,
    noLiPadding: (prop_types_default()).bool,
    navDropdown: (prop_types_default()).bool,
    // function that retuns the selected item
    onClick: (prop_types_default()).func
};


/***/ })

}]);